import { createRootRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { useEffect } from 'react';
import { useAuth } from '@/lib';
import { ErrorBoundary } from '@/components';
import { env, logger } from '@/lib';
import 'preline';

function RootLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    logger.info('Application mounted', { mode: env.mode });

    /* const initPreline = async () => {
      try {
        const { HSStaticMethods } = await import('preline');
        HSStaticMethods.autoInit();
      } catch (error) {
        logger.warn('Preline initialization failed', { error });
      }
    };

    initPreline(); */
  }, []);

/*   useEffect(() => {
    const reinitPreline = async () => {
      try {
        const { HSStaticMethods } = await import('preline');
        HSStaticMethods.autoInit();
      } catch (error) {
        logger.warn('Preline re-initialization failed', { error });
      }
    };

    reinitPreline();
  }, [location.pathname]); */



  useEffect(() => {
    window.HSStaticMethods.autoInit();
  }, [location.pathname]);


  useEffect(() => {
    const publicPaths = ['/login', '/register', '/forgot-password', '/reset-password', '/login-magic'];
    const isPublicPath = publicPaths.some(path => location.pathname.startsWith(path));
    
    if (!isLoading && !isAuthenticated && !isPublicPath) {
      navigate({ to: '/login' });
    }
  }, [isAuthenticated, isLoading, navigate, location.pathname]);

  return (
    <ErrorBoundary>
      <Outlet />
      {env.isDev && <TanStackRouterDevtools position="bottom-right" />}
    </ErrorBoundary>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});
